var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"icp-page d-flex-center"},[_c('div',{staticClass:"text"},[_vm._v("© 2023-2024 All Rights Reserved")]),_c('div',{staticClass:"link"},[_vm._v("@粤ICP备xxxxxxxxxxxxxx号-23")])])
}]

export { render, staticRenderFns }